export default __webpack_public_path__ + "static/media/dropdown.c5180c3b.svg";